<footer class="bg-accent-900 shadow-black-inset rounded-full p-1">
  <nav class="bg-primary-700 xs:gap-10 flex w-full flex-row items-stretch justify-center gap-4 rounded-full px-3 py-2 text-center sm:gap-16">
    @for (item of navItems(); track $index) { @if (item.extras) {
    <button
      class="text-primary-300 group flex flex-col items-center gap-2 text-left transition-colors duration-300 hover:text-white"
      cdkOverlayOrigin
      [clicks]="'menu-nav-' + item.label"
      [preventDefault]="false"
      (click)="isOpen.set(!isOpen())">
      <span class="relative my-auto block aspect-square w-6">
        <icon-app
          class="absolute inset-0 transition-opacity duration-300 group-hover:opacity-0"
          [style.opacity]="isOpen() ? '0' : null"
          [name]="item.inactive_icon" />
        <icon-app
          class="absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
          [style.opacity]="isOpen() ? '1' : null"
          [name]="item.active_icon" />
      </span>
      <span
        class="preset-title-6 text-center whitespace-nowrap"
        [class.text-white]="isOpen()">
        {{ item.label }}
      </span>
    </button>
    } @else {
    <a
      class="text-primary-300 group flex flex-col items-center gap-2 text-left transition-colors duration-300 hover:text-white"
      [routerLink]="item.route"
      [clicks]="'menu-nav-' + item.label">
      <span class="relative my-auto block aspect-square w-6">
        <icon-app
          class="absolute inset-0 transition-opacity duration-300 group-hover:opacity-0"
          [style.opacity]="isActive(item.route!) ? '0' : null"
          [name]="item.inactive_icon" />
        <icon-app
          class="absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
          [style.opacity]="isActive(item.route!) ? '1' : null"
          [name]="item.active_icon" />
      </span>
      <span
        class="preset-title-6 text-center whitespace-nowrap"
        [class.text-white]="isActive(item.route!)">
        {{ item.label }}
      </span>
    </a>
    } }
  </nav>
</footer>

@if (isOpen()) {
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger()!"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'bg-black/30'"
  cdkConnectedOverlayWidth="auto"
  (backdropClick)="isOpen.set(false)"
  (detach)="isOpen.set(false)">
  <extras-dropdown (selected)="isOpen.set(false)" />
</ng-template>
}
